module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "heading"
    },
    slot: "heading"
  }, [_vm._v("Shows the proportion of profiles active across two channels.")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "Loading Cross Platform Engagement..."
    }
  }, [(_vm.engagements.length && !_vm.loading) ? _c('div', {
    staticClass: "cross-engagement-profiles"
  }, [_c('cross-profile-table', {
    staticStyle: {
      "margin": "8px 0"
    },
    attrs: {
      "profilesData": _vm.data
    }
  })], 1) : _c('div', {
    staticStyle: {
      "height": "525px"
    }
  }, [_c('small', {
    staticClass: "graph-empty"
  }, [_vm._v("No Data Loaded")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34b16dab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/charts/CrossPlatformEngagement.vue
// module id = 3212
// module chunks = 3